export const paywallModule = {
  name: 'Paywall',
};
